import { QuoteProps } from './types'

export const getDefaultQuotes = (): QuoteProps[] => {
	return [
		{
			tag: 'Night sweats',
			author: 'Jamie, Florida',
			content:
				'“A few months ago I was diagnosed with breast cancer, and experienced symptoms from treatment (hot flashes and night sweats). This product is a game changer for me, and that this should be considered a device for durable medical equipment.”',
		},
		{
			tag: 'Snoring',
			author: 'Victoria, New York',
			content: '“The Base is amazing. Really transforms the sleep experience. Helping me stay asleep rather than waking up from my snoring.”',
		},
		{
			tag: 'Recovery',
			author: 'Justin, Texas',
			content:
				"“The ability to actively monitor your sleep metrics and correlate those to periods of over training or even sickness has helped me identify when to give my body rest. Eight Sleep has been one of the best investments I've made for my wellbeing.”",
		},
	]
}
